<template>
  <div
    class="page flex-col"
    style="
      background: url(/static/loginBg.jpg) no-repeat;
      background-size: 100% 100vh;
    "
  >
    <div class="containBox">
      <div class="tittleName">
        <div>
          <el-image
            style="width: 156px; height: 80px"
            :src="loginImg"
            fit="contain"></el-image>
        </div>
        <div style="line-height: 90px">
          天禄云枢古籍数据库
        </div>
      </div>
      <div :class="{'mainBox':true}">
        <div :class="{'tabBox':true,'tabListMy':true}">
          <div :class="{'tabList':true,'tabListActive':true}">重置密码</div>
          <div :class="{'tabList':true}"></div>
        </div>
        <div class="mainBox2">
          <!--       手机号+验证码   -->
          <div class="login-container" v-show="(registType==='phoneKey')||(registType==='phoneKeyCode')">
            <el-form :model="loginForm2" :rules="rules2" ref="loginForm2">
              <!-- 区号+手机号组合输入 -->
              <el-form-item prop="mobile">
                <el-input v-model="loginForm2.mobile" placeholder="请输入手机号">
                  <el-select
                    v-model="loginForm2.areaCode"
                    slot="prepend"
                    style="width: 120px"
                    placeholder="选择区号"
                    @change="handleAreaCodeChange"
                  >
                    <el-option
                      v-for="item in codeList"
                      :key="item"
                      :value="item"
                      :label="'+' + item"
                    />
                  </el-select>
                </el-input>
              </el-form-item>
              <!-- 密码输入（带眼睛图标） -->
              <el-form-item prop="password">
                <el-input
                  v-model="loginForm2.password"
                  placeholder="请输入新密码"
                  show-password
                >
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  v-model="loginForm2.password2"
                  placeholder="请再次输入新密码"
                  show-password
                >
                </el-input>
              </el-form-item>
              <el-form-item prop="smsCode">
                <div class="code-input-group">
                  <el-input
                    style="width: 65%"
                    v-model="loginForm2.smsCode"
                    placeholder="请输入验证码"
                  ></el-input>
                  <el-button
                    class="send-btn"
                    :disabled="!canSend || countdown > 0"
                    @click="sendSMSCode"
                  >
                    {{ countdownText }}
                  </el-button>
                </div>
              </el-form-item>
              <div @click="handleLogin2" class="buttonBox" v-loading="loading2">重置密码</div>
              <div class="layer6 flex-row justify-between" style="margin-top: 10px;padding: 0 15px">
                <el-checkbox class="checked" v-model="checked2"
                ><span class="bfore">閲讀并同意</span>使用條款與隱私政策</el-checkbox
                >
                <span class="loginStyle"  @click="goLogin">已有账号？去登录</span>
              </div>
            </el-form>
          </div>
          <!--        邮箱密码登录  -->
          <div class="login-container" v-show="registType==='emailKey'">
            <el-form :model="loginForm3" :rules="rules3" ref="loginForm3">
              <!-- 区号+手机号组合输入 -->
              <el-form-item prop="email">
                <el-input
                  v-model="loginForm3.email"
                  placeholder="请输入邮箱地址"
                  prefix-icon="el-icon-message"
                  clearable
                ></el-input>
              </el-form-item>

              <!-- 密码输入（带眼睛图标） -->
              <el-form-item prop="password">
                <el-input
                  v-model="loginForm3.password"
                  placeholder="请输入新密码"
                  show-password
                >
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  v-model="loginForm3.password2"
                  placeholder="请再次输入新密码"
                  show-password
                >
                </el-input>
              </el-form-item>
              <el-form-item prop="smsCode">
                <div class="code-input-group">
                  <el-input
                    style="width: 65%"
                    v-model="loginForm3.smsCode"
                    placeholder="请输入验证码"
                  ></el-input>
                  <el-button
                    class="send-btn"
                    :disabled="!canSend2 || countdown2 > 0"
                    @click="sendSMSCode2"
                  >
                    {{ countdownText2 }}
                  </el-button>
                </div>
              </el-form-item>
              <div @click="handleLogin3" class="buttonBox" v-loading="loading3">重置密码</div>
              <div class="layer6 flex-row justify-between" style="margin-top: 10px;padding: 0 15px">
                <el-checkbox class="checked" v-model="checked3"
                ><span class="bfore">閲讀并同意</span>使用條款與隱私政策</el-checkbox
                >
                <span class="loginStyle"  @click="goLogin">已有账号？去登录</span>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  resetpw,
  getPhoneKeyCode,
  registerEmail,
  registerEmailCode,
  resetpwEmail,
  getPhoneCode
} from "@/api/api"
import eventBus from "@/utils/eventBus.js"
export default {
  name: "regist",
  data () {
    // 手机号验证规则
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号'))
      }

      // 根据不同区号使用不同验证规则
      const areaCode = this.loginForm2.areaCode
      let regex

      switch(areaCode) {
        case '86': // 中国
          regex = /^1[3-9]\d{9}$/
          break
        case '1': // 美国
          regex = /^\d{10}$/
          break
        // 其他区号规则...
        default:
          regex = /^\d{6,15}$/ // 默认通用规则
      }
      console.log(value)
      console.log(areaCode)
      //console.log(value.replace(/^\+?\d+\s*/, ''))
      console.log(regex.test(value))
      if (!regex.test(value)) {
        return callback(new Error(`请输入有效的手机号`))
      }

      callback()
    }
    // 邮箱验证规则
    const validateEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('邮箱不能为空'));
      }
      if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)) {
        return callback(new Error('请输入有效的邮箱地址'));
      }
      callback();
    };
    // 自定义密码校验
    const validatePassword=(rule, value, callback)=> {
      if (!value) {
        return callback(new Error('请输入密码'));
      }

      // 长度校验
      if (value.length < 8 || value.length > 16) {
        return callback(new Error('密码长度需在8-16位之间'));
      }

      // 复杂度校验
      const hasUpperCase = /[A-Z]/.test(value);
      const hasLowerCase = /[a-z]/.test(value);
      const hasNumber = /[0-9]/.test(value);

      if (!hasUpperCase) {
        return callback(new Error('必须包含至少一个大写字母'));
      }
      if (!hasLowerCase) {
        return callback(new Error('必须包含至少一个小写字母'));
      }
      if (!hasNumber) {
        return callback(new Error('必须包含至少一个数字'));
      }

      callback();
    };
    return {
      registType:'',
      loading2:false,
      loading3:false,
      loginType:'phoneKey',
      loginForm2: {
        areaCode: '86', // 默认中国区号
        mobile: '',
        smsCode: '',
        uuid:''
      },
      loginForm3: {
        email: '',
        uuid: '',
        smsCode: '',
        password: ''
      },
      rules2: {
        mobile: [
          { validator: validatePhone, trigger: 'blur' }
        ],
        smsCode: [{ required: true, message: '验证码不能为空', trigger: 'blur' }],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ],
        password2: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ]
      },
      rules3: {
        email: [
          { validator: validateEmail, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ],
        password2: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ],
        smsCode: [{ required: true, message: '验证码不能为空', trigger: 'blur' }],
      },
      codeList: [],
      checked2: false,
      checked3: false,
      loginImg:'/static/loginNew.png',
      daokeImg:'/static/daokeLogin.png',
      countdown: 0,          // 倒计时秒数
      countdown2: 0,          // 倒计时秒数
      lastSendTime: null,     // 上次发送时间戳
      lastSendTime2: null,     // 上次发送时间戳
      canSend: true,          // 能否发送验证码
      canSend2: true          // 能否发送验证码
    }
  },
  computed: {
    // 倒计时显示文本
    countdownText() {
      return this.countdown > 0 ? `${this.countdown}s后重新获取` : '获取验证码';
    },
    countdownText2() {
      return this.countdown2 > 0 ? `${this.countdown2}s后重新获取` : '获取验证码';
    }
  },
  mounted () {
    getPhoneCode().then(res => {
      this.codeList = res.data || []
      this.ac = this.codeList[0] || ""
    })
  },
  created(){
    if (this.$route.query && this.$route.query.type) {
      this.registType=this.$route.query.type
    }
  },
  methods:{
    goLogin(type){
      this.$router.push({
        name: 'LoginNew',
        query: {
          type:this.registType
        },
      })
    },
    // 区号变化处理
    handleAreaCodeChange(type) {
      if(type='phoneKey'){
        this.loginForm.mobile = '' // 清空手机号输入
        this.$refs.loginForm.clearValidate('mobile') // 清除验证状态
      }

    },
    // 手机发送短信验证码
    async sendSMSCode() {
      try {
        // 验证手机号格式
        await this.$refs.loginForm2.validateField('mobile');

        // 检查发送频率（60秒内只能发一次）
        const now = Date.now();
        if (this.lastSendTime && now - this.lastSendTime < 60000) {
          this.$message.warning('操作过于频繁，请稍后再试');
          return;
        }

        // 开始倒计时
        this.startCountdown();
        this.lastSendTime = now;

        // 调用发送验证码API
        getPhoneKeyCode({
          mobile: `+${this.loginForm2.areaCode}${this.loginForm2.mobile}`,
        }).then(res => {
          if(res.code === 200){
            this.loginForm2.uuid=res.uuid
            this.$message.success('验证码已发送');
          }else{
            this.$message.error(res.msg)
          }
        })
      } catch (error) {
        this.$message.error(error.message || '发送失败');
      }
    },
// 邮箱发送短信验证码
    async sendSMSCode2() {
      try {
        // 验证手机号格式
        await this.$refs.loginForm3.validateField('email');

        // 检查发送频率（60秒内只能发一次）
        const now = Date.now();
        if (this.lastSendTime2 && now - this.lastSendTime2 < 60000) {
          this.$message.warning('操作过于频繁，请稍后再试');
          return;
        }

        // 开始倒计时
        this.startCountdown2();
        this.lastSendTime2 = now;

        // 调用发送验证码API
        registerEmailCode({
          email:this.loginForm3.email
        }).then(res => {
          if(res.code === 200){
            this.loginForm3.uuid=res.uuid
            this.$message.success('验证码已发送');
          }else{
            this.$message.error(res.msg)
          }
        })
      } catch (error) {
        this.$message.error(error.message || '发送失败');
      }
    },
    // 开始60秒倒计时
    startCountdown() {
      this.countdown = 60;
      this.canSend = false;

      const timer = setInterval(() => {
        this.countdown--;

        if (this.countdown <= 0) {
          clearInterval(timer);
          this.canSend = true;
        }
      }, 1000);
    },
    startCountdown2() {
      this.countdown2 = 60;
      this.canSend2 = false;

      const timer = setInterval(() => {
        this.countdown2--;

        if (this.countdown2 <= 0) {
          clearInterval(timer);
          this.canSend2 = true;
        }
      }, 1000);
    },
    // 手机号验证码
    async handleLogin2() {
      if (!this.checked2) {
        this.$message.warning("請先閱讀條款並同意勾選")
        return
      }
      if(this.loginForm2.password!==this.loginForm2.password2){
        this.$message.warning("两次密码不一致")
        return
      }
      try {
        await this.$refs.loginForm2.validate();

        const params = {
          //areaCode: this.loginForm.areaCode,
          mobile: `+${this.loginForm2.areaCode}${this.loginForm2.mobile}`,
          uuid: this.loginForm2.uuid,
          smsCode: this.loginForm2.smsCode,
          password:this.loginForm2.password
        }
        this.loading2=true
        // 调用登录API
        resetpw(params).then(res => {
          this.loading2=false
          if(res.code === 200){
            this.$message.success("重置密码成功")
            this.$router.push({
              name: 'LoginNew',
            })
          }else{
            this.loading2=false
            this.$message.error(res.msg)
          }
        })
      } catch (error) {
        this.loading2=false
        this.$message.error('重置密码失败');
      }
    },
    //邮箱注册
    // 处理登录
    async handleLogin3() {
      if (!this.checked3) {
        this.$message.warning("請先閱讀條款並同意勾選")
        return
      }
      if(this.loginForm3.password!==this.loginForm3.password2){
        this.$message.warning("两次密码不一致")
        return
      }
      try {
        const valid = await this.$refs.loginForm3.validate();
        if (!valid) return;

        this.loading3 = true;

        // 调用登录API
        resetpwEmail(this.loginForm3).then(res => {
          this.loading3=false
          if(res.code === 200){
            this.$message.success("重置密码成功")
            this.$router.push({
              name: 'LoginNew',
            })

          }else{
            this.$message.error(res.msg)
          }
        })
      } catch (error) {
        this.loading3=false
        this.$message.error('重置密码失败');
      } finally {
        this.loading3 = false;
      }
    },
  }
}

</script>
<style lang="less" scoped>
/deep/.el-input-group__prepend div.el-select .el-input__inner{
  background-color: #fff;
  border:1px solid #DBB054;
  border-right: none;
  border-radius: 4px 0 0 4px;
}
/deep/.el-form-item.is-error .el-input__inner{
  border: 1px solid #DBB054;
}
/deep/.el-input-group--prepend .el-select .el-input.is-focus .el-input__inner{
  border: 1px solid #DBB054;
  border-right: none;
}
/deep/.el-input__inner{
  height: 48px;
  line-height: 48px;
  border: 1px solid #DBB054;
}
/deep/.el-form-item__content{
  line-height: 48px;
}
/deep/.el-input__suffix{
  right: 15px;
}
/deep/ .el-checkbox__label {
  color: #795636;
  font-size: 0.81rem;
  font-weight: 400;
  font-family: FZShuSong-Z01T;
  .bfore {
    color: #2B2B2B;
  }
}
/deep/ .el-checkbox__inner {
  border: 1px solid #DBB054;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner,.el-checkbox__input.is-checked.is-focus .el-checkbox__inner{
  border: 1px solid #DBB054;
  background-color: #DBB054;
}
/deep/.el-checkbox__input.is-checked+.el-checkbox__label{
  color: #795636;
}
.page {
  position: relative;
  width: 100%;
  height: 100vh;
  //background-color: rgba(245, 245, 245, 1);
  overflow: hidden;
  /* display: flex;
   justify-content: center;
   align-items: center;*/
  font-family: "Courier New", Courier, monospace;
  .loginStyle{
    color: #795636;
    font-weight: bold;
    cursor: pointer;
  }
  .containBox{
    width: 577px;
    height: 630px;
    margin: auto;
    .tittleName{
      display: flex;

      font-family: STSongti-SC, STSongti-SC;
      font-weight: 900;
      font-size: 32px;
      color: #36240C;
      text-align: center;
    }
    .mainBox{
      .tabBox{
        margin-top: -10px;
        display: flex;
        //justify-content: center;
        align-items: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #573E0D;
        line-height: 70px;
        .tabList{
          color: #fff;
          //margin-right: 20px;
          width: 50%;
          text-align: center;
        }
        .tabListActive{
          color: #573E0D;
          //border-bottom: 3px solid #634427;
        }
      }
      .tabListMy{
        background: url(/static/tabMy.png) no-repeat;
        background-size: 100%;
      }
      .tabListPart{
        background: url(/static/tabPart.png) no-repeat;
        background-size: 100%;
      }
      .mainBox2{
        background-color: #EDE4D3;
        padding: 26px 0;
        border-radius: 0 0 25px 25px;
        .login-container{
          width: 433px;
          margin: 0 auto;
          .tipBox{
            display: flex;
            justify-content: space-between;
            align-items: center;
            //line-height:40px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #795636;
            margin-top: -10px;
            padding: 0 15px;
          }
          .buttonBox{
            height: 48px;
            line-height: 48px;
            text-align: center;
            border-radius: 4px;
            background-color: #F9CE68;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 24px;
            color: #573E0D;
            margin-top: 10px;
            opacity: 0.8;
            cursor: pointer;
          }
          .buttonBox:hover{
            opacity: 1;
          }
          .send-btn{
            height: 48px;
            background-color: #F9CE68;
            border: none;
            color: #573E0D;
          }
        }
        .loginType{
          display: flex;
          width: 533px;
          margin:26px 0 0 70px;
          .loginTypeName{
            margin-left: 15px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #2B2B2B;
            line-height: 48px;
          }
          .loginFlag{
            width: 48px;
            height: 48px;
            background: #E8CD8E;
            border-radius: 50%;
            margin-left: 15px;
            font-size: 24px;
            i{
              color: #573E0D;
              margin: 12px;
            }
          }
        }
      }


    }

  }
}
</style>




// WEBPACK FOOTER //
// src/pages/resetWord.vue